import { writable } from 'svelte/store';

import { type ToastParam, type ToastsStore, type ToastsStoreState, ToastType } from './types';

import type { ComponentType } from 'svelte';

const initialValues: ToastsStoreState = {
    toasts: new Map([]),
};

const createStore = (): ToastsStore => {
    const store = writable(initialValues);
    const { subscribe, update, set } = store;

    const create = (type: ToastType, message: string | ComponentType, params: ToastParam) => {
        const toast = {
            type,
            message,
            params: {
                persistence: params.persistence,
            },
        };
        update((state) => {
            state.toasts.set(Symbol('Toast'), toast);
            return state;
        });
    };

    const success: ToastsStore['success'] = (message = 'Success', params: ToastParam = {}) => {
        create(ToastType.Success, message, params);
    };

    const error: ToastsStore['error'] = (message = 'Error', params: ToastParam = {}) => {
        create(ToastType.Error, message, params);
    };

    const clear: ToastsStore['clear'] = () => {
        update((state) => {
            return {
                ...state,
                toasts: new Map([]),
            };
        });
    };

    const removeByIndex: ToastsStore['removeByIndex'] = (key: symbol) => {
        update((state) => {
            state.toasts.delete(key);
            return state;
        });
    };

    return {
        set,
        update,
        subscribe,
        success,
        error,
        clear,
        removeByIndex,
        create,
    };
};

export const toastsStore = createStore();
